import CustomSkeletonTable from "../../ui/CustomSkeletonTable/CustomSkeletonTable";
import FetchFeedback from "../../ui/CustomFetchFeedback/CustomFetchFeedback";
import TransactionTableTanStack from "./tables/TransactionTableTanStack";
import {
  TransactionDetailsModal,
  ReassignTransactionModal,
  SplitTransactionModal,
} from "./modals";
import TransactionEmptyState from "./TransactionEmptyState";

const TransactionContent = ({
  data: {
    transactions,
    totalElements,
    totalPages,
    noTransactions,
    isLoading,
    isFetching,
    isError,
    onRetry,
  },
  paginationProps: { pagination, setPagination },
  filters: { searchQuery },
  merchants: { merchantOptions, isMerchantOptionsError },
  modals: { details: detailsModal, reassign: reassignModal, split: splitModal },
  isSuperAdmin,
  canSplitTransaction,
  canSeeKraFee,
  activeTab,
}) => {
  if (isLoading) {
    return (
      <CustomSkeletonTable
        columns={[1, 2, 3, 4, 5, 6, 7, 8]}
        rowCount={pagination.pageSize}
      />
    );
  }

  if (isError) {
    return (
      <FetchFeedback
        message={"Failed to load transactions. Please try again."}
        onRetry={onRetry}
      />
    );
  }

  if (noTransactions) {
    return <TransactionEmptyState searchQuery={searchQuery} />;
  }

  return (
    <>
      <TransactionTableTanStack
        pagination={pagination}
        data={transactions}
        onPaginationChange={setPagination}
        totalElements={totalElements}
        totalPages={totalPages}
        isLoading={isLoading}
        isFetching={isFetching}
        onRowClick={detailsModal.openModal}
        onReassignClick={reassignModal.openModal}
        onSplitClick={splitModal.openModal}
        isSuperAdmin={isSuperAdmin}
        canSplitTransaction={canSplitTransaction}
        canSeeKraFee={canSeeKraFee}
        merchantOptions={merchantOptions}
        isMerchantOptionsError={isMerchantOptionsError}
        activeTab={activeTab}
      />

      <TransactionDetailsModal
        opened={detailsModal.isOpen}
        onClose={detailsModal.closeModal}
        transactionData={detailsModal.transaction ?? {}}
        canSplitTransaction={canSplitTransaction}
        onSplitClick={(row) => {
          detailsModal.closeModal();
          splitModal.openModal(row);
        }}
      />
      <ReassignTransactionModal
        opened={reassignModal.isOpen}
        onClose={reassignModal.closeModal}
        transactionData={reassignModal.transaction ?? {}}
        merchantOptions={merchantOptions}
        control={reassignModal.control}
        onSubmit={reassignModal.handleSubmit}
        isSubmitting={reassignModal.isSubmitting}
      />
      <SplitTransactionModal
        opened={splitModal.isOpen}
        onClose={splitModal.closeModal}
        transactionData={splitModal.transaction ?? {}}
        control={splitModal.control}
        onSubmit={splitModal.handleSubmit}
        isSubmitting={splitModal.isSubmitting}
      />
    </>
  );
};

export default TransactionContent;
